document.addEventListener('DOMContentLoaded', (e) => {
    const swip = new Swiper(".section-wrapper-slider", {
        loop: true,
        lazy: {
            loadPrevNext: true,
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                autoplay: false,
                allowTouchMove: false
            },
            769: {
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
            },
        },
        modules: [Autoplay]
    });

    const toggleBtn = document.getElementById("swiper-toggle");
    let isPlaying = true;
    if (!toggleBtn) return;
    toggleBtn.addEventListener("click", () => {
        if (isPlaying) {
            swip.autoplay.stop();
            toggleBtn.innerHTML = `<img src="/wp-content/themes/lvl-framework-child/dist/img/aim-play.svg" alt="" class="aim-play-control">`;
        } else {
            swip.autoplay.start();
            toggleBtn.innerHTML = `<img src="/wp-content/themes/lvl-framework-child/dist/img/aim-pause.svg" alt="" class="aim-pause-control">`;
        }
        isPlaying = !isPlaying;
    });
});

